import {} from '@busybusy/webapp-react-ui';
import { EquipmentInspectionCondition } from '__generated__/graphql';
import classNames from 'classnames';
import BasicPicker from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEProps {
  className?: ClassName;
  value: string | null;
  onSelect: (value: string | null) => void;
}

const EquipmentInspectionConditionPicker = (props: IEProps) => {
  const { className, value, onSelect } = props;

  const data: { id: string; name: string }[] = [
    { id: EquipmentInspectionCondition.Satisfactory, name: t('Satisfactory') },
    { id: EquipmentInspectionCondition.Unsatisfactory, name: t('Unsatisfactory') },
    { id: EquipmentInspectionCondition.NeedsAttention, name: t('Needs Attention') },
  ];

  const classes = classNames('equipment-inspection-condition-picker', className);

  return <BasicPicker className={classes} value={value} data={data} onSelect={onSelect} placeholder={t('Condition')} />;
};

export default EquipmentInspectionConditionPicker;
